<div class="page-content main-font container">
  <div class="calendar-area-toolbar">
    <button
      *ngFor="let area of getVisibleCalendarAreaOptions()"
      class="calendar-area-switch__btn"
      [class.calendar-area-switch__btn--active]="calendarArea == area.value"
      (click)="onCalendarAreaChange(area.value)">
      {{ area.label }}
    </button>
  </div>
  <table>
    <!-- Header Tabella -->
    <tr class="table-header">
      <th
        [ngClass]="{
          'cell-month': !column.date,
          'cell-day': column.date,
          'cell-today': column.is_today,
          'first-column': i == 1,
          'last-column': last
        }"
        *ngFor="let column of listOfColumns; let i = index; let last = last"
        #firstColumn>
        <ng-container *ngIf="!column.date">
          <div class="title-cell-month">
            <button (click)="moveWeek(-1)">
              <i class="icons arrow-left fill-svg-blue-700"></i>
            </button>
            <button
              class="primary-btn-outline-new w-100"
              (click)="openSidebarCalendar()">
              <i class="icon-calendar"></i>
              <div
                class="badge-notification"
                *ngIf="notifications?.months?.current?.total > 0">
                {{ notifications?.months?.current?.total }}
              </div>
              <div class="d-flex">
                <p class="mb-0 me-1">
                  {{ listOfColumns[1].date | date: 'd' }} -
                  {{ listOfColumns[5].date | date: 'd' }}
                  {{ capitalizeFirst(column.day) }}
                </p>
                <p class="mb-0">{{ column.year }}</p>
              </div>
            </button>
            <button (click)="moveWeek(1)">
              <i class="icons arrow-right fill-svg-blue-700"></i>
            </button>
            <button
              class="primary-btn-outline-new personalized-btn btn-filter"
              (click)="openSidebarCalendar()">
              <i class="icons filter-option fill-svg-blue-700"></i>
              <div
                *ngIf="
                  teamsIdSelected.length > 0 ||
                  roleIdSelected.length > 0 ||
                  eventsIdSelected.length > 0
                "
                class="btn-filter__badge"></div>
            </button>
          </div>
          <div class="calendar-toolbar">
            <div class="d-flex gap-2 w-100">
              <div class="w-100 h-100">
                <nz-select
                  [nzSuffixIcon]="searchIconTemplate"
                  class="w-100"
                  nzMode="multiple"
                  nzPlaceHolder="Cerca utente"
                  [nzMaxTagCount]="1"
                  [nzAllowClear]="true"
                  [nzDropdownClassName]="'custom-dropdown-theme'"
                  [(ngModel)]="usersSelected"
                  (ngModelChange)="onSelectUser($event)">
                  <nz-option
                    *ngFor="let user of activeUsers"
                    [nzValue]="user.id"
                    [nzLabel]="user.first_name + ' ' + user.last_name">
                  </nz-option>
                </nz-select>
                <ng-template #searchIconTemplate nzSuffixIcon>
                  <img
                    src="assets/images/icon_calendar/search.svg"
                    alt="search" />
                </ng-template>
              </div>
              <button
                *ngIf="userRole == 'admin'"
                routerLink="calendario-smart"
                class="primary-btn-new personalized-btn">
                <i class="icons smart fill-svg-grey-50"></i>
              </button>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="column.date">
          <div class="d-flex w-100">
            <div class="d-flex flex-column">
              <p class="mb-0 font-date">{{ column.date | date: 'd' }}</p>
              <p class="mb-0 font-day">{{ column.day }}</p>
            </div>
            <div class="d-flex justify-content-end w-100">
              <i
                class="icons bell fill-svg-orange-300"
                *ngIf="column.pending"></i>
            </div>
          </div>
          <!-- Le chips sotto il giorno le può vedere solo l'admin -->
          <div class="badge-container">
            <div
              class="chips-dayOff"
              *ngIf="column.dayType == 1 && !column.holiday">
              <i class="icons close-filled fill-svg-grey-600"></i>
              <p class="mb-0">Day off</p>
            </div>
            <div *ngIf="column.holiday" class="chips-holiday">
              <div class="container-chips">
                <img
                  src="assets/images/icon_calendar/holiday.svg"
                  alt="holiday"
                  class="icon-holiday" />
                <p class="mb-0">{{ column.holiday.title }}</p>
              </div>
            </div>
            <div
              *ngFor="let counter of column.counters"
              class="tiny-counter cursor-pointer"
              [ngClass]="{
                'tiny-counter-review': counter.typology === 'Review',
                'tiny-counter-sickness': counter.typology === 'Malattia',
                'tiny-counter-vacation': counter.typology === 'Ferie',
                'tiny-counter-permission': counter.typology === 'Permesso'
              }"
              nz-dropdown
              nzTrigger="click"
              [nzDropdownMenu]="users">
              <img
                [src]="getIcon('confirmed', counter.typology)"
                [alt]="counter.typology"
                class="tiny-icon-counter" />
              <p class="mb-0">
                {{ counter.counter }}
              </p>
              <nz-dropdown-menu #users>
                <ul nz-menu>
                  <li nz-menu-item *ngFor="let user of counter.users">
                    {{ user.first_name }} {{ user.last_name }}
                  </li>
                </ul>
              </nz-dropdown-menu>
            </div>
          </div>
        </ng-container>
      </th>
    </tr>

    <!-- Body Tabella -->
    <tr
      class="table-row position-relative"
      *ngFor="let user of users; let first = first; let last = last">
      <td class="user-cell">
        <div class="user-container">
          <div class="user-card">
            <div class="user-image-wrapper">
              <img
                [src]="utilityService.getSanitizeUrl(user.path)"
                alt=""
                class="user-image"
                [class.user-image--part-time]="isPartTimeUser(user)" />
              <div class="part-time-user-badge" *ngIf="isPartTimeUser(user)">
                Part-Time
              </div>
            </div>
            <div class="user-detail">
              <button class="btn-user" (click)="openCalendarUser(user)">
                <p class="user-name mb-0">
                  {{ user.first_name }} {{ user.last_name }}
                </p>
              </button>
              <div class="w-100">
                <div class="d-flex justify-content-between align-items-center">
                  <div
                    class="d-flex align-items-center gap-1"
                    *ngIf="user?.hollidays_count">
                    <div
                      class="badge-permission"
                      nz-tooltip="Ore permessi goduti">
                      <i class="icons clock fill-svg-blue-800"></i>
                      <p class="mb-0 text-badge-permission">
                        {{ user.hollidays_count.permessi }}
                      </p>
                    </div>
                    <div
                      class="badge-permission"
                      nz-tooltip="Giorni ferie goduti">
                      <i class="icons vacation fill-svg-blue-800"></i>
                      <p class="mb-0 text-badge-permission">
                        {{ user.hollidays_count.ferie }}
                      </p>
                    </div>
                    <div class="badge-permission" nz-tooltip="Giorni malattia">
                      <i class="icons sickness fill-svg-blue-800"></i>
                      <p class="mb-0 text-badge-permission">
                        {{ user.hollidays_count.malattie }}
                      </p>
                    </div>
                  </div>
                  <div class="badge-last-review" *ngIf="user?.last_review">
                    <img src="assets/images/icon_calendar/review.svg" alt="" />
                    <p class="mb-0 text-last-review">
                      +{{ user?.last_review }} gg
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </td>
      <!-- azione modale e dropdown -->
      <ng-container *ngFor="let day of user.days; let i = index">
        <td class="day-user-cell">
          <div class="day-user-content">
            <ng-container
              *ngIf="getPartTimeBadge(day, user) as badge; else smartCell">
              <ng-container
                *ngIf="
                  canOpenPartTimePendingPopover(day);
                  else simplePartTimeBadge
                ">
                <img
                  [src]="badge.src"
                  alt=""
                  class="part-time-badge cursor-pointer"
                  nz-tooltip
                  [nzTooltipTitle]="badge.tooltip"
                  nz-popover
                  [nzPopoverPlacement]="'left'"
                  [nzPopoverContent]="partTimePendingTemplate"
                  nzPopoverTrigger="click"
                  nzPopoverTitle=""
                  (click)="loadPartTimePendingRequest(user, day)" />
                <ng-template #partTimePendingTemplate>
                  <div class="pop-container main-font">
                    <div class="pop-list">
                      <div class="pop-list-container">
                        <div class="text-container">
                          <div class="pop-header">
                            <p class="mb-0 text-pop w-100">
                              Richiesta modifica orario settimanale
                            </p>
                          </div>

                          <ng-container
                            *ngIf="
                              getPartTimePendingRequest(day) as request;
                              else loadingPartTimePendingRequest
                            ">
                            <div class="user-msg-container">
                              <img
                                [src]="utilityService.getSanitizeUrl(user.path)"
                                [alt]="user.first_name"
                                class="msg-user-icon" />
                              <p class="mb-0 msg-user-name">
                                {{ user.first_name }} {{ user.last_name }}
                              </p>
                            </div>

                            <div class="msg-container" *ngIf="request.note">
                              <div class="msg-text-container">
                                <p class="mb-0 msg-text w-100">
                                  {{ request.note }}
                                </p>
                              </div>
                            </div>

                            <div
                              *ngIf="
                                !canManagePartTimePendingRequest(request) &&
                                request.status === 'pending'
                              "
                              class="chips-request chips-request-pending">
                              <i class="icons pending fill-svg-orange-600"></i>
                              <p class="mb-0 text-pending-pm">
                                In attesa di risposta dall'Amministrazione
                              </p>
                            </div>

                            <div class="part-time-pop-days">
                              <div class="part-time-pop-days-header">
                                <p class="mb-0 pop-text-info"></p>
                                <p
                                  class="mb-0 pop-text-info text-end part-time-pop-header-default">
                                  Default
                                </p>
                                <p
                                  class="mb-0 pop-text-info text-end part-time-pop-header-request">
                                  Richiesta
                                </p>
                              </div>

                              <div
                                *ngFor="let scheduleDay of request.days"
                                class="part-time-pop-day-row">
                                <p class="mb-0 pop-text-info">
                                  {{ getWeekdayLabel(scheduleDay.weekday) }}
                                </p>
                                <p class="mb-0 pop-text-info text-end">
                                  {{
                                    getPartTimeScheduleLabel(
                                      getDefaultPartTimeScheduleDay(
                                        request,
                                        scheduleDay.weekday
                                      )
                                    )
                                  }}
                                </p>
                                <p class="mb-0 pop-text-info text-end">
                                  {{ getPartTimeScheduleLabel(scheduleDay) }}
                                </p>
                              </div>
                            </div>

                            <div
                              *ngIf="canManagePartTimePendingRequest(request)"
                              class="btn-container">
                              <button
                                class="secondary-btn-outline-new small w-100"
                                (click)="
                                  openModalRejectPartTimePendingRequest(request)
                                ">
                                <p class="mb-0">Rifiuta</p>
                              </button>
                              <button
                                class="primary-btn-new small w-100"
                                (click)="
                                  approvePartTimePendingRequest(request)
                                ">
                                <p class="mb-0">Accetta</p>
                              </button>
                            </div>
                          </ng-container>

                          <ng-template #loadingPartTimePendingRequest>
                            <p class="mb-0 pop-text-info">
                              Caricamento dettaglio richiesta...
                            </p>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-container>
              <ng-template #simplePartTimeBadge>
                <img
                  [src]="badge.src"
                  alt=""
                  class="part-time-badge"
                  nz-tooltip
                  [nzTooltipTitle]="badge.tooltip" />
              </ng-template>
            </ng-container>
            <ng-template #smartCell>
              <ng-container
                *ngIf="getSmartRequest(day, user) as request; else empty">
                <i
                  [class]="getSmartClass(day, user)"
                  nz-tooltip
                  [nzTooltipTitle]="getSmartTooltip(day, user)"
                  nz-popover
                  [nzPopoverPlacement]="'left'"
                  [nzPopoverContent]="
                    request?.status == 'pending' ? smartTemplate : ''
                  "
                  nzPopoverTrigger="click"
                  nzPopoverTitle=""></i>
                <!-- Template per le richieste smart -->
                <ng-template #smartTemplate>
                  <div class="pop-container main-font">
                    <div class="pop-list">
                      <div class="pop-list-container">
                        <div class="text-container">
                          <div class="pop-header">
                            <p class="mb-0 text-pop w-100">
                              {{
                                request.status == 'pending'
                                  ? 'Richiesta cambio smart'
                                  : ''
                              }}
                            </p>
                          </div>
                          <div
                            class="msg-container"
                            *ngIf="request.type != 'Review' && request.note">
                            <div class="user-msg-container">
                              <img
                                [src]="utilityService.getSanitizeUrl(user.path)"
                                [alt]="user.first_name"
                                class="msg-user-icon" />
                              <p class="mb-0 msg-user-name">
                                {{ user.first_name }} {{ user.last_name }}
                              </p>
                            </div>
                            <div class="msg-text-container">
                              <p class="mb-0 msg-text w-100">
                                {{ request.note }}
                              </p>
                            </div>
                          </div>
                          <p
                            *ngIf="
                              userRole != 'admin' &&
                              request.status == 'pending' &&
                              isUserLoggedRequest(request)
                            "
                            class="msg-request mb-0">
                            In attesa di conferma dall'Admin
                          </p>
                          <div class="pop-info">
                            <i [class]="getSmartClass(day, user)"></i>
                            <p class="mb-0 pop-text-info">
                              {{
                                (request.start_date
                                  | date: 'EEE d/MM/yyyy'
                                  | titlecase) +
                                  ' ' +
                                  (request.start_date + 'T' + request.start_time
                                    | date: 'H:mm') +
                                  ' - ' +
                                  (request.end_date + 'T' + request.end_time
                                    | date: 'H:mm')
                              }}
                            </p>
                          </div>
                          <!-- Bottini Elimina e Modifica Review per l'Admin -->
                          <div
                            *ngIf="userRole == 'admin'"
                            class="btn-container">
                            <button
                              class="secondary-btn-outline-new small w-100"
                              (click)="deleteEventModal(user, request)">
                              <p class="mb-0">
                                {{
                                  request.type == 'Review'
                                    ? 'Elimina'
                                    : 'Rifiuta'
                                }}
                              </p>
                            </button>
                            <button
                              class="primary-btn-new small w-100"
                              (click)="
                                openModal(user, request.start_date, request)
                              ">
                              <p class="mb-0">
                                {{
                                  request.type == 'Review'
                                    ? 'Modifica'
                                    : 'Accetta'
                                }}
                              </p>
                            </button>
                          </div>
                          <!-- Bottoni per tutti tranne l'Admin -->
                          <div
                            *ngIf="canShowEditDeleteButtons(request)"
                            class="btn-container">
                            <button
                              *ngIf="canDeleteEvent(request)"
                              class="secondary-btn-outline-new small w-100"
                              (click)="
                                deleteEventModal(
                                  user,
                                  request,
                                  canForceManageEvents()
                                )
                              ">
                              <p class="mb-0">Elimina</p>
                            </button>
                            <button
                              *ngIf="
                                request.type != 'Malattia' ||
                                canEditEvent(request)
                              "
                              class="primary-btn-new small w-100"
                              (click)="
                                openModal(
                                  user,
                                  request.start_date,
                                  request,
                                  canForceManageEvents()
                                )
                              ">
                              <p class="mb-0">Modifica</p>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-container>
              <ng-template #empty>
                <i
                  [class]="getSmartClass(day, user)"
                  nz-tooltip
                  [nzTooltipTitle]="getSmartTooltip(day, user)"></i>
              </ng-template>
            </ng-template>
            <ng-container *ngIf="canCreateRequestsForUsers(user)">
              <a nz-dropdown [nzDropdownMenu]="adminMenu" class="add-event-btn">
                <img
                  src="assets/images/icon_calendar/add_blue.svg"
                  alt=""
                  class="icon-add-event" />
              </a>
              <nz-dropdown-menu
                #adminMenu="nzDropdownMenu"
                style="border-radius: 50px">
                <ul nz-menu class="m-0">
                  <li
                    *ngIf="canCreateReviewForUsers()"
                    nz-menu-item
                    (click)="openModalReview(user, day.date)"
                    class="p-3"
                    onKeyPress="">
                    <img
                      src="/assets/images/icon_calendar/review.svg"
                      alt="review"
                      class="px-2" />
                    Review
                  </li>
                  <hr
                    *ngIf="
                      canCreateReviewForUsers() &&
                      !isHolidayDate(day.date) &&
                      day.dayType != 1 &&
                      getAdminRequestTypes(user, day.date).length > 0
                    "
                    class="m-0 p-0" />
                  <ng-container
                    *ngIf="!isHolidayDate(day.date) && day.dayType != 1">
                    <ng-container
                      *ngFor="
                        let item of getAdminRequestTypes(user, day.date);
                        let last = last
                      ">
                      <li
                        nz-menu-item
                        (click)="
                          openRequestModal(
                            user,
                            day.date,
                            item.label,
                            item,
                            false
                          )
                        "
                        class="p-3"
                        onKeyPress="">
                        <img
                          [src]="
                            '/assets/images/icon_request_modal/' + item.icon
                          "
                          [alt]="item.alt"
                          class="px-2"
                          [class]="{
                            'ps-1': item.alt == 'request_smart'
                          }" />
                        {{ item.label }}
                      </li>
                      <hr *ngIf="!last" class="m-0 p-0" />
                    </ng-container>
                  </ng-container>
                </ul>
              </nz-dropdown-menu>
            </ng-container>
            <div *ngIf="!canCreateRequestsForUsers(user)">
              <a
                *ngIf="
                  day.date >= today &&
                  user.id === profileData?.id &&
                  !isHolidayDate(day.date) &&
                  day.dayType != 1 &&
                  getAvailableRequestTypes(user, day.date).length > 0
                "
                nz-dropdown
                [nzDropdownMenu]="menu"
                class="add-event-btn">
                <img
                  src="assets/images/icon_calendar/add_blue.svg"
                  alt=""
                  class="icon-add-event" />
              </a>
              <!-- Elenco richieste -->
              <nz-dropdown-menu
                #menu="nzDropdownMenu"
                style="border-radius: 50px">
                <ul nz-menu class="m-0">
                  <ng-container
                    *ngFor="
                      let item of getAvailableRequestTypes(user, day.date);
                      let last = last
                    ">
                    <li
                      nz-menu-item
                      (click)="
                        openRequestModal(
                          user,
                          day.date,
                          item.label,
                          item,
                          false
                        )
                      "
                      class="p-3"
                      onKeyPress="">
                      <!-- Caso singola icona -->
                      <ng-container>
                        <img
                          [src]="
                            '/assets/images/icon_request_modal/' + item.icon
                          "
                          [alt]="item.alt"
                          class="px-2"
                          [class]="{
                            'ps-1': item.alt == 'request_smart'
                          }" />
                        {{ item.label }}
                      </ng-container>
                    </li>
                    <hr *ngIf="!last" class="m-0 p-0" />
                  </ng-container>
                </ul>
              </nz-dropdown-menu>
            </div>
          </div>
        </td>

        <!-- chips eventi -->
        <ng-container
          *ngFor="let request of getRequestsForDay(user, day); let i = index">
          <div
            class="padding-cell-day"
            *ngIf="
              !request.type.includes('Smart') &&
              !request.type.includes('Presenza')
            ">
            <!-- apre la modale Malattia da certificare -->
            <div
              *ngIf="
                request.type === 'Malattia' &&
                  (userRole == 'user' || userRole == 'team_leader') &&
                  !isUserLoggedRequest(request);
                else sicknessPendingOwner
              "
              class="position-absolute chips-request chips-request-sickness"
              [ngStyle]="getStyleChips(user, request, i, day)">
              <img
                [src]="getIcon('confirmed', request.type, true)"
                alt="icon" />
              <p class="mb-0 text-format">Malattia</p>
            </div>
            <ng-template #sicknessPendingOwner>
              <div
                *ngIf="
                  request.type === 'Malattia' && request.status === 'pending';
                  else otherRequests
                "
                class="position-absolute chips-request"
                [ngClass]="{
                  'chips-request-pending': request.status == 'pending',
                  'chips-request-sickness': request.status == 'approved'
                }"
                [ngStyle]="{
                  left:
                    columnUserWidth +
                    192 *
                      calculateStartRequest(
                        user.days[0].date,
                        request.start_date
                      ) +
                    8 +
                    'px',
                  width:
                    192 *
                      calculateTotalDays(request.start_date, request.end_date) -
                    16 +
                    'px',
                  bottom: i * 26 + 4 + 'px',
                  cursor:
                    !isUserLoggedRequest(request) && userRole != 'admin'
                      ? 'default'
                      : 'pointer'
                }"
                (click)="
                  isUserLoggedRequest(request) ||
                  canCreateRequestsForUsers(user)
                    ? openRequestModal(
                        user,
                        day.date,
                        'Malattia da certificare',
                        request
                      )
                    : null
                "
                onKeyPress="">
                <img
                  [src]="getIcon(request.status, request.type)"
                  alt="icon"
                  *ngIf="!request.type.includes('Smart')" />
                <p class="mb-0">
                  {{ getPermission(request.type, request.status) }}
                </p>
              </div>
            </ng-template>
            <!-- Template per le richieste (Ferie, Permessi, Malatttie) -->
            <ng-template #otherRequests>
              <div
                nz-popover
                [nzPopoverPlacement]="'left'"
                [nzPopoverContent]="contentTemplate"
                nzPopoverTrigger="click"
                nzPopoverTitle=""
                class="position-absolute chips-request cursor-pointer"
                [ngClass]="{
                  'chips-request-pending':
                    request.status == 'pending' || request.status == 'approved',
                  'chips-request-permission':
                    request.type === 'Permesso' &&
                    request.status == 'confirmed',
                  'chips-request-vacation':
                    request.type === 'Ferie' && request.status == 'confirmed',
                  'chips-request-sickness':
                    request.type === 'Malattia' &&
                    request.status == 'confirmed',
                  'chips-request-review':
                    request.type == 'Review' && request.status == 'confirmed'
                }"
                [ngStyle]="getStyleChips(user, request, i, day)">
                <img
                  [src]="getIcon(request.status, request.type, true)"
                  alt="icon" />
                <p class="mb-0 text-format">
                  {{ getPermission(request.type, request.status) }}
                </p>
              </div>
            </ng-template>
            <!-- Pop Over -->
            <ng-template #contentTemplate>
              <div class="pop-container main-font">
                <div class="pop-list">
                  <div class="pop-list-container">
                    <div class="text-container">
                      <div class="pop-header">
                        <p class="mb-0 text-pop w-100">
                          {{ getPermission(request.type, request.status) }}
                        </p>
                      </div>
                      <div class="pop-info">
                        <!-- passo 'approved' cos' nel pophover vedo l'icona corrispondente alla richiesta -->
                        <img
                          [src]="getIcon('approved', request.type)"
                          alt="icon"
                          class="icon-pop" />
                        <p class="mb-0 pop-text-info">
                          {{
                            request.type == 'Review' ||
                            request.type == 'Permesso'
                              ? (request.start_date
                                  | date: 'EEE d/MM/yyyy'
                                  | titlecase) +
                                ' ' +
                                (request.start_date + 'T' + request.start_time
                                  | date: 'H:mm')
                              : capitalizeFirst(
                                  request?.start_date | date: 'EEE d/MM/yyyy'
                                )
                          }}
                          -
                          {{ formatRequestDate(request) }}
                        </p>
                      </div>
                      <div
                        class="user-msg-container"
                        *ngIf="request.type != 'Review'">
                        <img
                          [src]="utilityService.getSanitizeUrl(user.path)"
                          [alt]="user.first_name"
                          class="msg-user-icon" />
                        <p class="mb-0 msg-user-name">
                          {{ user.first_name }} {{ user.last_name }}
                        </p>
                      </div>
                      <!-- Contenitore del messaggio della richiesta -->
                      <div
                        class="msg-container"
                        *ngIf="
                          (isUserLoggedRequest(request) ||
                            userRole === 'project_manager' ||
                            userRole === 'admin' ||
                            userRole === 'hr_manager') &&
                          request.type != 'Review' &&
                          request.note
                        ">
                        <div class="msg-text-container">
                          <p class="mb-0 msg-text w-100">
                            {{ request.note }}
                          </p>
                        </div>
                      </div>
                      <!-- Contenitore degli utenti che devono accettare la richiesta -->
                      <div
                        *ngIf="canShowPmContainer(request, user)"
                        class="pm-container">
                        <div
                          *ngFor="let user of request.approvals"
                          class="d-flex justify-content-between align-items-center w-100">
                          <div class="d-flex gap-2 align-items-center">
                            <img
                              [src]="
                                utilityService.getSanitizeUrl(user.filestorage)
                              "
                              alt=""
                              class="user-image-pm" />
                            <p class="mb-0 text-name-pm">
                              {{ user.first_name }} {{ user.last_name }}
                            </p>
                          </div>
                          <div class="d-flex align-items-center gap-1">
                            <i
                              [class]="
                                user.is_approved
                                  ? 'icons check fill-svg-green-700'
                                  : 'icons pending fill-svg-orange-300'
                              "></i>
                            <p class="mb-0 text-status-request">
                              {{ user.is_approved ? 'Accettata' : 'In attesa' }}
                            </p>
                          </div>
                        </div>
                        <div
                          class="chips-request chips-request-pending"
                          *ngIf="request.status == 'approved'">
                          <i class="icons pending fill-svg-orange-600"></i>
                          <p class="mb-0 text-pending-pm">
                            In attesa di risposta dall'Amministrazione
                          </p>
                        </div>
                        <!-- Alert per capire se abbiamo accettato la richiesta -->
                        <div
                          class="request-accepted-container w-100"
                          *ngIf="
                            isUserLoggedAcceptedRequest(request.approvals)
                          ">
                          <i class="icons check fill-svg-green-700"></i>
                          <p class="mb-0 text-request-accepted">
                            Hai accettato la richiesta
                          </p>
                          <img
                            [src]="
                              utilityService.getSanitizeUrl(
                                profileData.filestorage.path
                              )
                            "
                            [alt]="profileData.first_name"
                            class="user-image-pm" />
                        </div>
                        <p
                          class="mb-0 msg-text"
                          *ngIf="
                            request.status === 'approved' &&
                            (userRole == 'admin' ||
                              canHrConfirmRequest(request, user))
                          ">
                          Riporta la risposta dell'amministrazione ricevuta via
                          email
                        </p>
                      </div>
                      <!-- Bottini Elimina e Modifica Review per l'Admin -->
                      <div
                        *ngIf="canShowManagementButtons(request, user)"
                        class="btn-container">
                        <button
                          class="secondary-btn-outline-new small w-100"
                          (click)="
                            request.type == 'Review'
                              ? deleteEventModal(user, request)
                              : openModalRejectRequest(request)
                          ">
                          <p class="mb-0">
                            {{
                              request.type == 'Review' ? 'Elimina' : 'Rifiuta'
                            }}
                          </p>
                        </button>
                        <button
                          class="primary-btn-new small w-100"
                          (click)="
                            openModal(user, request.start_date, request)
                          ">
                          <p class="mb-0">
                            {{
                              request.type == 'Review' ? 'Modifica' : 'Accetta'
                            }}
                          </p>
                        </button>
                      </div>
                      <!-- Bottoni per tutti tranne l'Admin -->
                      <div
                        *ngIf="canShowEditDeleteButtons(request)"
                        class="btn-container">
                        <button
                          *ngIf="canDeleteEvent(request)"
                          class="secondary-btn-outline-new small w-100"
                          (click)="
                            deleteEventModal(
                              user,
                              request,
                              canForceManageEvents()
                            )
                          ">
                          <p class="mb-0">Elimina</p>
                        </button>
                        <button
                          *ngIf="
                            request.type != 'Malattia' || canEditEvent(request)
                          "
                          class="primary-btn-new small w-100"
                          (click)="
                            openModal(
                              user,
                              request.start_date,
                              request,
                              canForceManageEvents()
                            )
                          ">
                          <p class="mb-0">Modifica</p>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </div>
        </ng-container>
      </ng-container>
    </tr>
    <app-sidebar-calendar
      (dateEmitter)="onDateChange($event)"
      (teamsEmitter)="onTeamsChange($event)"
      (rolesEmitter)="onRolesChange($event)"
      (eventsEmitter)="onEventsChange($event)"
      (filterUsersrequest)="onFilterUsersRequest($event)"
      (onPageChangeCalendar)="getNotifications($event)"
      [monthSelected]="monthSelected"
      [widthColumn]="columnUserWidth"
      [isSideOpen]="isSideOpen"
      [userRole]="userRole"
      [profileData]="profileData"
      [notifications]="notifications"
      (closed)="onSidebarClosed()"></app-sidebar-calendar>
  </table>
</div>
